import { ComponentRef, Directive, Input, OnChanges, OnDestroy, ViewContainerRef } from '@angular/core';
import { StepperStatusEnum } from '../models/stepper-status-enum';
import { LogService } from '../services/log.service';
import { StepperService } from '../services/stepper.service';

@Directive({
  selector: '[appStepperDirective]'
})
export class StepperDirective implements OnChanges, OnDestroy {

  @Input() componentName: string;
  @Input() status: StepperStatusEnum;
  @Input() stepperVersion: string;

  componentInstance: ComponentRef<any>;

  constructor(private vcRef: ViewContainerRef,
    private stepperService: StepperService,
    private LOG: LogService) {
  }

  ngOnChanges() {
    this.LOG.log("[DIRECTIVE CHANGE : {0} | {1} ]", this.componentName, this.status);

    if (this.status === StepperStatusEnum.EMPTY) {
      this.destroy();
      return;
    }
    if (this.status === StepperStatusEnum.CREATE) {
      this.destroy();
      this.componentInstance = this.stepperService.buildComponent(this.componentName, this.vcRef);
      this.status = StepperStatusEnum.VISIT;
      return;
    }
    if (this.status === StepperStatusEnum.VISIT) {
      return;
    }
  }

  public ngOnDestroy() {
    this.destroy();
  }

  destroy() {
    this.stepperService.clear(this.componentName);
    if (this.componentInstance) {
      this.componentInstance.destroy();
      this.componentInstance = null;
    }
  }
}
